import React, { forwardRef, useCallback, useMemo } from "react";
import { Turnstile } from "@marsidev/react-turnstile";

const TurnstileWidget = forwardRef(
  ({ siteKey, onSuccess, onError, onExpire }, ref) => {
    const handleError = useCallback(
      (error) => {
        onError?.(error || "Verification failed. Please try again.");
      },
      [onError],
    );

    const handleScriptError = useCallback(() => {
      onError?.("Failed to load Cloudflare Turnstile.");
    }, [onError]);

    const options = useMemo(
      () => ({
        theme: "light",
        size: "flexible",
        responseField: false,
      }),
      [],
    );

    const scriptOptions = useMemo(
      () => ({
        appendTo: "body",
        onError: handleScriptError,
      }),
      [handleScriptError],
    );

    return (
      <Turnstile
        ref={ref}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onError={handleError}
        onExpire={onExpire}
        onTimeout={handleError}
        options={options}
        scriptOptions={scriptOptions}
      />
    );
  },
);

TurnstileWidget.displayName = "TurnstileWidget";

export default TurnstileWidget;
